var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { I18nService } from "@app/core";
import { Title } from "@angular/platform-browser";
import { AuthService } from "@app/auth.service";
import { Router, NavigationEnd } from "@angular/router";
import { UserService } from "@app/user.service";
import { UtilService } from "@app/utility/util.service";
import { ApiService } from "@app/utility/api.service";
import { NotiService } from "@app/noti.service";
import { CryptographyService } from "@app/cryptography.service";
var MainmenuComponent = /** @class */ (function () {
    function MainmenuComponent(i18nService, titleService, Auth, router, user, util, apiService, notiService, crypto) {
        var _this = this;
        this.i18nService = i18nService;
        this.titleService = titleService;
        this.Auth = Auth;
        this.router = router;
        this.user = user;
        this.util = util;
        this.apiService = apiService;
        this.notiService = notiService;
        this.crypto = crypto;
        this.isCrisis = true;
        this.cookieData = {};
        this.isLoggedIn = false;
        this.firstname = "";
        this.lastname = "";
        this.notiList = [];
        this.dict = {};
        this.UnreadCount = 0;
        this.contactId = "";
        this.imgProfileSrc = "";
        this.lang = "th";
        this.simulateMenu = {};
        this.contactDpaMenu = {};
        this.faqMenu = {};
        this.loginMenu = {};
        this.trackStatusMenu = {};
        this.inquiryMenu = {};
        this.reqNewDocMenu = {};
        this.statusReqNewDocMenu = {};
        this.banklistMenu = {};
        this.aboutUsMenu = {};
        this.fbLoginBtn = {};
        this.lineLoginBtn = {};
        this.googleLoginBtn = {};
        this.regisMenu = {};
        this.logoutMenu = {};
        router.events.subscribe(function (val) {
            // see also
            if (val instanceof NavigationEnd) {
                _this.InitText(val.url);
                var ActivatedComponent = val.url.substring(val.url.lastIndexOf('/') + 1, val.url.length);
                if (ActivatedComponent.toLocaleLowerCase() != "refunddeposits") {
                    var CookieData = localStorage.getItem("dpa_portal");
                    if (CookieData != null && CookieData != "") {
                        CookieData = JSON.parse(CookieData);
                        CookieData.refundState = "";
                        localStorage.setItem("dpa_portal", JSON.stringify(CookieData));
                    }
                }
            }
        });
    }
    MainmenuComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var thisTs, ck, _a, crisisConfig, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        thisTs = this;
                        this.util.ShowWaiting(true);
                        ck = JSON.parse(localStorage.getItem("dpa_portal"));
                        if (ck == null) {
                            localStorage.setItem("dpa_portal", "{}");
                            this.cookieData = {};
                        }
                        else {
                            this.cookieData = ck;
                        }
                        if (this.cookieData != null && this.cookieData.contactid != null && this.cookieData.contactid.trim().length != 0) {
                            this.isLoggedIn = true;
                            if (this.cookieData.lang == null || this.cookieData.lang == "") {
                                this.cookieData.lang = "th-TH";
                            }
                        }
                        else {
                            this.isLoggedIn = false;
                            this.cookieData.lang = "th-TH";
                        }
                        this.notiService.langChange(this.cookieData.lang.substring(0, 2));
                        this.setLanguage(this.cookieData.lang);
                        _a = this;
                        return [4 /*yield*/, this.apiService.get("master", "configuration")];
                    case 1:
                        _a.config = _c.sent();
                        crisisConfig = this.config.filter(function (c) {
                            return c.dpa_name == "CRISIS FLAG";
                        });
                        if (crisisConfig != null && crisisConfig.length > 0 && crisisConfig[0].dpa_crisisflag != null && crisisConfig[0].dpa_crisisflag == true) {
                            this.cookieData.isCrisis = true;
                            this.isCrisis = true;
                            localStorage.setItem("dpa_portal", JSON.stringify(this.cookieData));
                        }
                        else {
                            this.cookieData.isCrisis = false;
                            this.isCrisis = false;
                            this.isLoggedIn = false;
                            this.firstname = "";
                            this.lastname = "";
                            this.contactId = "";
                            this.imgProfileSrc = "";
                            this.cookieData.firstname = this.firstname;
                            this.cookieData.lastname = this.lastname;
                            this.cookieData.contactid = this.contactId;
                            localStorage.setItem("dpa_portal", JSON.stringify(this.cookieData));
                        }
                        return [4 /*yield*/, this.getUserLoggedIn()];
                    case 2:
                        _c.sent();
                        _b = this;
                        return [4 /*yield*/, this.apiService.get("master", "customerPortalMenuSetting")];
                    case 3:
                        _b.menuList = _c.sent();
                        this.simulateMenu = this.util.getMenuObj(this.menuList, "01", this.isCrisis);
                        this.contactDpaMenu = this.util.getMenuObj(this.menuList, "02", this.isCrisis);
                        this.faqMenu = this.util.getMenuObj(this.menuList, "03", this.isCrisis);
                        this.loginMenu = this.util.getMenuObj(this.menuList, "04", this.isCrisis);
                        this.trackStatusMenu = this.util.getMenuObj(this.menuList, "05", this.isCrisis);
                        this.inquiryMenu = this.util.getMenuObj(this.menuList, "06", this.isCrisis);
                        this.reqNewDocMenu = this.util.getMenuObj(this.menuList, "1001", this.isCrisis);
                        this.statusReqNewDocMenu = this.util.getMenuObj(this.menuList, "1002", this.isCrisis);
                        this.banklistMenu = this.util.getMenuObj(this.menuList, "07", this.isCrisis);
                        this.fbLoginBtn = this.util.getMenuObj(this.menuList, "08", this.isCrisis);
                        this.lineLoginBtn = this.util.getMenuObj(this.menuList, "09", this.isCrisis);
                        this.googleLoginBtn = this.util.getMenuObj(this.menuList, "10", this.isCrisis);
                        this.regisMenu = this.util.getMenuObj(this.menuList, "11", this.isCrisis);
                        this.aboutUsMenu = this.util.getMenuObj(this.menuList, "1000", this.isCrisis);
                        if (!gapi.auth2) {
                            gapi.load('auth2', function () {
                                gapi.auth2.init();
                            });
                        }
                        FB.init({
                            appId: '214693200435388',
                            cookie: true,
                            xfbml: true,
                            version: 'v3.1'
                        });
                        this.util.ShowWaiting(false);
                        $.fn.datepicker.defaults.format = "dd/mm/yyyy";
                        //$('[data-provide="datepicker"]').after('<i class="fa fa-calendar" style="color: var(--cust-blue)" aria-hidden="true"></i>');
                        $('[data-provide="datepicker"]').each(function () {
                            if ($(this).attr("placeholder") == "") {
                                $(this).attr("placeholder", "DD/MM/YYYY");
                            }
                        });
                        // $('[data-provide="datepicker"]').attr("placeholder", "DD/MM/YYYY");
                        $(".modal")
                            .on("hidden.bs.modal", function (e) {
                            if ($(".modal:visible").length) {
                                $(".modal-backdrop")
                                    .first()
                                    .css("z-index", parseInt($(".modal:visible").last().css("z-index")) - 10);
                                $("body").addClass("modal-open");
                            }
                        })
                            .on("show.bs.modal", function (e) {
                            if ($(".modal:visible").length) {
                                $(".modal-backdrop.in")
                                    .first()
                                    .css("z-index", parseInt($(".modal:visible").last().css("z-index")) + 10);
                                $(this).css("z-index", parseInt($(".modal-backdrop.in").first().css("z-index")) + 10);
                            }
                        });
                        $(".user-menu").on("click", function () {
                            //thisTs.ClaerActiveTabMenu();
                            //if (this.id != null && this.id != undefined && this.id != "") {
                            //$(thisTs).addClass("active");
                            thisTs.router.navigate([this.id == "" ? thisTs.router.url : ("/mainmenu/" + this.id)]);
                            //}
                        });
                        $("document").on("click", function () {
                            $("body").addClass("sidebar-collapse");
                        });
                        $("#btnmenuMobile").on("click", function () {
                            $("aside").toggleClass("menuburger");
                            $("#btnmenuMobile img").toggleClass("imgToggle");
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    MainmenuComponent.prototype.InitText = function (urlpath) {
        return __awaiter(this, void 0, void 0, function () {
            var targetUrlArray;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        document.body.className = 'h-100 sidebar-collapse';
                        //clear active tab menu
                        return [4 /*yield*/, this.ClaerActiveTabMenu()];
                    case 1:
                        //clear active tab menu
                        _a.sent();
                        targetUrlArray = urlpath.split("/");
                        if (targetUrlArray.length > 0) {
                            try {
                                $("#a_" + targetUrlArray[targetUrlArray.length - 1]).prop("aria-selected", true);
                                $("#a_" + targetUrlArray[targetUrlArray.length - 1]).addClass("active");
                                $("#b_" + targetUrlArray[targetUrlArray.length - 1]).prop("aria-selected", true);
                                $("#b_" + targetUrlArray[targetUrlArray.length - 1]).addClass("active");
                            }
                            catch (e) {
                            }
                        }
                        //if (urlpath == '/mainmenu') {
                        this.cookieData = JSON.parse(localStorage.getItem("dpa_portal"));
                        return [4 /*yield*/, this.getUserLoggedIn()
                            //
                            // }
                        ];
                    case 2:
                        _a.sent();
                        //
                        // }
                        if (urlpath == '/mainmenu') {
                            this.goToIndex();
                        }
                        this.util.InitValidation();
                        return [2 /*return*/];
                }
            });
        });
    };
    MainmenuComponent.prototype.setLanguage = function (language) {
        this.cookieData.lang = language;
        localStorage.setItem("dpa_portal", JSON.stringify(this.cookieData));
        this.i18nService.language = language;
        this.lang = language.substring(0, 2);
        this.notiService.langChange(this.lang);
    };
    MainmenuComponent.prototype.InitLangImage = function () {
        var image = document.getElementById("imgLang");
        var res = this.i18nService.language.split("-");
        image.src = "assets/dist/img/lang/flags_iso/16/" + res[0] + ".png";
    };
    MainmenuComponent.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            var dataobj, data;
            return __generator(this, function (_a) {
                dataobj = {};
                dataobj["member_no"] = this.util.GetUserID();
                data = this.user.logout();
                if (data.status) {
                    //  await this.apiService.postnotauthen('account', 'DeleteUserSession', dataobj);
                    this.Auth.setLoggedIn(false);
                    this.router.navigate(["login"]);
                }
                else {
                    window.alert("Some problem");
                }
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(MainmenuComponent.prototype, "languages", {
        get: function () {
            return this.i18nService.supportedLanguages;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainmenuComponent.prototype, "title", {
        get: function () {
            return this.titleService.getTitle();
        },
        enumerable: true,
        configurable: true
    });
    MainmenuComponent.prototype.ClaerActiveTabMenu = function () {
        $(".user-menu").each(function () {
            $(this).removeClass("active");
        });
    };
    MainmenuComponent.prototype.goToIndex = function () {
        this.router.navigate(["mainmenu/index"]);
    };
    MainmenuComponent.prototype.goToLogin = function () {
        if ($("aside").hasClass("menuburger")) {
            $("aside").toggleClass("menuburger");
            $("#btnmenuMobile img").toggleClass("imgToggle");
        }
        this.router.navigate(["mainmenu/login"]);
    };
    MainmenuComponent.prototype.goToProfile = function () {
        if ($("aside").hasClass("menuburger")) {
            $("aside").toggleClass("menuburger");
            $("#btnmenuMobile img").toggleClass("imgToggle");
        }
        var url = this.util.baseUrl() + "/mainmenu/profile";
        window.open(url, "_blank");
    };
    MainmenuComponent.prototype.goToContactDpa = function () {
        if ($("aside").hasClass("menuburger")) {
            $("aside").toggleClass("menuburger");
            $("#btnmenuMobile img").toggleClass("imgToggle");
        }
        var url = 'https://www.dpa.or.th/Inquiries';
        window.open(url, "_blank");
    };
    MainmenuComponent.prototype.goToFaq = function () {
        if ($("aside").hasClass("menuburger")) {
            $("aside").toggleClass("menuburger");
            $("#btnmenuMobile img").toggleClass("imgToggle");
        }
        var url = 'https://www.dpa.or.th/faq';
        window.open(url, "_blank");
    };
    MainmenuComponent.prototype.goToAboutUs = function () {
        if ($("aside").hasClass("menuburger")) {
            $("aside").toggleClass("menuburger");
            $("#btnmenuMobile img").toggleClass("imgToggle");
        }
        this.router.navigate(["mainmenu/aboutUs"]);
    };
    MainmenuComponent.prototype.goToNews = function () {
        this.router.navigate(["/mainmenu/allNews"]);
    };
    MainmenuComponent.prototype.newsNotiClick = function (newsId) {
        var news = this.notiList.filter(function (noti) {
            return noti.dpa_newandactivityid == newsId;
        });
        if (news != null && news.length > 0) {
            //this.notiList.splice(this.notiList.indexOf(news[0]), 1)
            if (this.notiList[this.notiList.indexOf(news[0])].isRead == null) {
                this.notiList[this.notiList.indexOf(news[0])].isRead = true;
                this.UnreadCount--;
                var ReadList = [];
                if (this.cookieData.readNewsList != null && this.cookieData.readNewsList != "") {
                    ReadList = JSON.parse(this.cookieData.readNewsList);
                }
                ReadList.push({
                    username: this.cookieData.email,
                    usernameidno: "",
                    newsid: newsId
                });
                this.cookieData.readNewsList = ReadList;
                localStorage.setItem("dpa_portal", JSON.stringify(this.cookieData));
                var req = {
                    username: this.cookieData.email,
                    usernameidno: "",
                    newsid: newsId
                };
                this.apiService.postCustomApi("User", "ReadNewsNoti", req);
            }
        }
        // let req: any = {
        //   username: this.cookieData.email,
        //   usernameidno: "",
        //   newsid: newsId
        // }
        // this.apiService.postCustomApi("User", "ReadNewsNoti", req)
        var url = this.util.baseUrl() + "/news/" + newsId;
        window.open(url, "_blank");
    };
    MainmenuComponent.prototype.signOut = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoggedIn = false;
                        this.firstname = "";
                        this.lastname = "";
                        this.util.ShowWaiting(true);
                        return [4 /*yield*/, this.util.getIPAddress().subscribe(function (res) {
                                _this.util.ShowWaiting(false);
                                var req = {
                                    username: _this.cookieData.email,
                                    customerid: _this.cookieData.contactid,
                                    ip: res.json().ip
                                };
                                _this.apiService.postCustomApi("User", "Logout", req);
                                _this.cookieData.firstname = "";
                                _this.cookieData.lastname = "";
                                _this.cookieData.email = "";
                                _this.cookieData.contactid = "";
                                _this.cookieData.imgProfileSrc = "";
                                localStorage.setItem("dpa_portal", JSON.stringify(_this.cookieData));
                                var auth2 = gapi.auth2.getAuthInstance();
                                auth2.signOut().then(function () {
                                    console.log('User signed out.');
                                });
                                FB.getLoginStatus(function (response) {
                                    if (response && response.status === 'connected') {
                                        FB.logout(function (response) {
                                            console.log("Logged Out!");
                                        });
                                    }
                                });
                                _this.goToIndex();
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MainmenuComponent.prototype.goToMenuClick = function (endPointUrl) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if ($("aside").hasClass("menuburger")) {
                            $("aside").toggleClass("menuburger");
                            $("#btnmenuMobile img").toggleClass("imgToggle");
                        }
                        return [4 /*yield*/, this.ClaerActiveTabMenu()];
                    case 1:
                        _a.sent();
                        //if (this.id != null && this.id != undefined && this.id != "") {
                        $("#a_" + endPointUrl).addClass("active");
                        $("#b_" + endPointUrl).addClass("active");
                        this.router.navigate(["/mainmenu/" + endPointUrl]);
                        return [2 /*return*/];
                }
            });
        });
    };
    MainmenuComponent.prototype.getUserLoggedIn = function () {
        return __awaiter(this, void 0, void 0, function () {
            var para, newsList_1, readList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.cookieData != null && this.cookieData.contactid != null && this.cookieData.contactid.trim().length != 0)) return [3 /*break*/, 2];
                        this.isLoggedIn = true;
                        this.firstname = this.cookieData.firstname;
                        this.lastname = this.cookieData.lastname;
                        this.contactId = this.cookieData.contactid;
                        this.imgProfileSrc = this.cookieData.imgUrl;
                        para = "dpa_publishstatus=true&dpa_isdisplayoncustomerportal=true&dpa_isdisplayoncustomcrmweb=false&dpa_iscrisis=" + this.isCrisis.toString();
                        return [4 /*yield*/, this.apiService.get("crmservice", "news", para)];
                    case 1:
                        newsList_1 = _a.sent();
                        if (this.cookieData.readNewsList == null) {
                            this.notiList = newsList_1;
                            this.UnreadCount = newsList_1.length;
                        }
                        else {
                            readList = this.cookieData.readNewsList;
                            readList.forEach(function (cn) {
                                var toBeRemove = newsList_1.filter(function (n) {
                                    return n.dpa_newandactivityid == cn.newsid;
                                });
                                if (toBeRemove != null && toBeRemove.length > 0) {
                                    //newsList.splice(newsList.indexOf(toBeRemove[0]), 1)
                                    newsList_1[newsList_1.indexOf(toBeRemove[0])].isRead = true;
                                }
                            });
                            this.UnreadCount = newsList_1.length < readList.length ? 0 : newsList_1.length - readList.length;
                            this.notiList = newsList_1;
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        this.isLoggedIn = false;
                        this.firstname = "";
                        this.lastname = "";
                        this.contactId = "";
                        this.imgProfileSrc = "";
                        this.cookieData.firstname = this.firstname;
                        this.cookieData.lastname = this.lastname;
                        this.cookieData.contactid = this.contactId;
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return MainmenuComponent;
}());
export { MainmenuComponent };



// WEBPACK FOOTER //
// ./src/app/mainmenu/mainmenu.component.ts.pre-build-optimizer.js